export const selectWorkTypesList = (store) =>
  store.workTypesState.sort((a, b) => a < b );



// WEBPACK FOOTER //
// ./src/store/selectors/workTypes.js